export type IAddressChangeFormFifthSection = {
    Signature?: string;
    SignatureDate?: string;
}

export const AddressChangeFormFifthSectionInitialState = (): IAddressChangeFormFifthSection => ({
    Signature: undefined,
    SignatureDate: undefined
})